import type { SSOSettings, SSOEditableSettings } from 'types/sso';
import api from 'helpers/api';

export const fetchSSOSettings = () => api.get<SSOSettings>('/settings/sso');
export const createSSOSettings = (settings: SSOEditableSettings) => api.post('/settings/sso', settings);
export const updateSSOSettings = (settings: Partial<SSOEditableSettings>) => api.patch('/settings/sso', settings);
